(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('appraiser-user', {
            parent: 'entity',
            url: '/appraiser-user?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'valueconnectApp.appraiserUser.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/appraiser-user/appraiser-users.html',
                    controller: 'AppraiserUserController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('appraiserUser');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('appraiser-user-detail', {
            parent: 'entity',
            url: '/appraiser-user/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'valueconnectApp.appraiserUser.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/appraiser-user/appraiser-user-detail.html',
                    controller: 'AppraiserUserDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('appraiserUser');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'AppraiserUser', function($stateParams, AppraiserUser) {
                    return AppraiserUser.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('appraiser-user.new', {
            parent: 'appraiser-user',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/appraiser-user/appraiser-user-dialog.html',
                    controller: 'AppraiserUserDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                designationCRA: false,
                                designationAACI: false,
                                designationId: null,
                                aicActive: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('appraiser-user', null, { reload: true });
                }, function() {
                    $state.go('appraiser-user');
                });
            }]
        })
        .state('appraiser-user.edit', {
            parent: 'appraiser-user',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/appraiser-user/appraiser-user-dialog.html',
                    controller: 'AppraiserUserDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AppraiserUser', function(AppraiserUser) {
                            return AppraiserUser.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('appraiser-user', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('appraiser-user.delete', {
            parent: 'appraiser-user',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/appraiser-user/appraiser-user-delete-dialog.html',
                    controller: 'AppraiserUserDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AppraiserUser', function(AppraiserUser) {
                            return AppraiserUser.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('appraiser-user', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
